import axios from 'axios';


const clienteAxios = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL || 'https://app.dev.pampa4.ar:4000'
});

export default clienteAxios;